/**
 * 
 */

document.querySelectorAll(".dropdown").forEach((dropdown) => {
    var navLink = dropdown.querySelector(".nav-link");
    var dropdowMenu = dropdown.querySelector(".dropdown-menu");

    if (navLink) {
        navLink.addEventListener('mouseleave', () => {
            dropdowMenu?.classList.remove('show');
        });
    }
});